import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {WritableDraft} from "immer/dist/internal";
import {RootState} from "../../app/store";
import {SliceStatus} from "../BaseState";
import {RejectError} from "./Error";
import {ErrorHandlerState} from "./ErrorHandlerState";

const initialState: ErrorHandlerState = {
  pendings: [],
  status: SliceStatus.idle,
  error: null
};

export const errorHandlerSlice = createSlice({
  name: "errorHandler",
  initialState,
  reducers: {
    setError: (draft: WritableDraft<ErrorHandlerState>, action: PayloadAction<RejectError>) => {
      draft.error = action.payload;
    }
  }
});

export const {setError} = errorHandlerSlice.actions;
export const errorHandlerState = (state: RootState): ErrorHandlerState => state.errorHandler;
export default errorHandlerSlice.reducer;
